function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 17C0 7.61116 7.61116 0 17 0C26.3888 0 34 7.61116 34 17C34 26.3888 26.3888 34 17 34C7.61116 34 0 26.3888 0 17Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1218_3593)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.1399 16.2474C21.5952 16.6458 21.5952 17.3542 21.1399 17.7526L15.6585 22.5488C15.0119 23.1146 14 22.6554 14 21.7962L14 12.2038C14 11.3446 15.0119 10.8854 15.6585 11.4512L21.1399 16.2474Z",
  fill: "#CDCDCD"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M17 33C8.16344 33 1 25.8366 1 17H-1C-1 26.9411 7.05887 35 17 35V33ZM33 17C33 25.8366 25.8366 33 17 33V35C26.9411 35 35 26.9411 35 17H33ZM17 1C25.8366 1 33 8.16344 33 17H35C35 7.05887 26.9411 -1 17 -1V1ZM17 -1C7.05887 -1 -1 7.05887 -1 17H1C1 8.16344 8.16344 1 17 1V-1Z",
  fill: "#CDCDCD"
});

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1218_3593"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 14,
  fill: "white",
  transform: "translate(10 10)"
})));

var SvgBigArrowCalendar = function SvgBigArrowCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBigArrowCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/big-arrow-calendar.c984278d.svg";
export { ForwardRef as ReactComponent };